export default "__VITE_ASSET__ae81b99c__"